
(()=>{
  const root=document.querySelector('[data-bpl-root]'); if(!root) return;
  const cfgEl=root.querySelector('[data-bpl-config]');
  const cfg=JSON.parse(cfgEl.textContent);
  const grid=root.querySelector('[data-bpl-grid]');
  const search=root.querySelector('[data-bpl-search]');
  const filters=root.querySelector('[data-bpl-filters]');
  const count=root.querySelector('[data-bpl-count]');
  const dialog=root.querySelector('[data-bpl-dialog]');
  const detail=root.querySelector('[data-bpl-detail]');
  const toast=root.querySelector('[data-bpl-toast]');
  let index=[], active='Todos'; const chunkCache=new Map();
  const esc=(s='')=>String(s).replace(/[&<>'"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]));
  const normalize=s=>(s||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
  const showToast=(msg)=>{toast.textContent=msg;toast.classList.add('show');clearTimeout(showToast.t);showToast.t=setTimeout(()=>toast.classList.remove('show'),1800)};
  async function loadIndex(){
    const res=await fetch(cfg.indexUrl,{credentials:'same-origin'}); if(!res.ok) throw new Error('No se pudo cargar el índice');
    index=await res.json(); buildFilters(); render(); openFromHash();
  }
  function buildFilters(){
    const cats=['Todos',...new Set(index.map(x=>x.category))];
    filters.innerHTML=cats.map((c,i)=>`<button class="bpl-filter" type="button" data-cat="${esc(c)}" aria-pressed="${i===0?'true':'false'}">${esc(c)}</button>`).join('');
  }
  function filtered(){
    const q=normalize(search.value.trim());
    return index.filter(x=>(active==='Todos'||x.category===active) && (!q || normalize(`${x.title} ${x.objective} ${x.category} ${x.format}`).includes(q)));
  }
  function render(){
    const list=filtered(); count.textContent=`${list.length} contenido${list.length===1?'':'s'}`;
    if(!list.length){grid.innerHTML='<div class="bpl-empty">No encontramos contenidos con esos filtros.</div>';return;}
    grid.innerHTML=list.map(x=>`<article class="bpl-card">
      <div class="bpl-card-top"><span class="bpl-badge">${esc(x.category)}</span><span class="bpl-number">${esc(x.number)}</span></div>
      <h3>${esc(x.title)}</h3><p>${esc(x.objective)}</p>
      <div class="bpl-card-footer"><button class="bpl-open" type="button" data-open="${esc(x.slug)}">Ver contenido</button><span class="bpl-format">${esc(x.format)}</span></div>
    </article>`).join('');
  }
  async function loadRecord(meta){
    if(!chunkCache.has(meta.chunk)){
      const url=cfg.chunks[meta.chunk];
      const res=await fetch(url,{credentials:'same-origin'}); if(!res.ok) throw new Error('No se pudo cargar el contenido');
      chunkCache.set(meta.chunk,await res.json());
    }
    return chunkCache.get(meta.chunk).find(x=>x.slug===meta.slug);
  }
  async function openItem(slug,push=true){
    const meta=index.find(x=>x.slug===slug); if(!meta) return;
    detail.innerHTML='<div class="bpl-loader">Cargando contenido…</div>'; dialog.showModal(); document.documentElement.style.overflow='hidden';
    if(push) history.replaceState(null,'',`#${encodeURIComponent(slug)}`);
    try{
      const r=await loadRecord(meta);
      detail.innerHTML=`
        <div class="bpl-detail-head"><div><strong>${esc(r.category)}</strong><br><small>${esc(r.format)}</small></div><button class="bpl-close" type="button" aria-label="Cerrar" data-close>×</button></div>
        <div class="bpl-detail-body">
          <div class="bpl-number">CONTENIDO ${esc(r.number)}</div>
          <h1 class="bpl-detail-title">${esc(r.title)}</h1>
          <p class="bpl-objective">${esc(r.objective)}</p>
          <div class="bpl-explain-grid">
            <section class="bpl-info"><h2>Por qué funciona</h2>${r.why_html}</section>
            <section class="bpl-info"><h2>Errores que debes evitar</h2>${r.errors_html}</section>
            <section class="bpl-info bpl-wide"><h2>Estructura del contenido</h2>${r.structure_html}</section>
            <section class="bpl-info bpl-wide"><h2>Checklist antes de publicar</h2>${r.checklist_html}</section>
          </div>
          <h2 class="bpl-prompts-title">Elige cómo quieres crearlo</h2>
          <div class="bpl-prompts">
            <section class="bpl-prompt"><div class="bpl-prompt-head"><h3>Prompt para carrusel</h3><button class="bpl-copy" type="button" data-copy="carousel">Copiar prompt</button></div><pre>${esc(r.carousel_prompt)}</pre></section>
            <section class="bpl-prompt"><div class="bpl-prompt-head"><h3>Prompt para Reel</h3><button class="bpl-copy" type="button" data-copy="reel">Copiar prompt</button></div><pre>${esc(r.reel_prompt)}</pre></section>
          </div>
        </div>`;
      detail.querySelector('[data-close]').addEventListener('click',closeDialog);
      detail.querySelectorAll('[data-copy]').forEach(btn=>btn.addEventListener('click',async()=>{
        const val=btn.dataset.copy==='carousel'?r.carousel_prompt:r.reel_prompt;
        try{await navigator.clipboard.writeText(val);showToast('Prompt copiado ✓')}catch(e){showToast('Selecciona y copia el texto manualmente')}
      }));
    }catch(e){detail.innerHTML=`<div class="bpl-loader">No pudimos cargar este contenido. Intenta de nuevo.</div>`}
  }
  function closeDialog(){dialog.close();document.documentElement.style.overflow='';history.replaceState(null,'',location.pathname+location.search)}
  function openFromHash(){const slug=decodeURIComponent(location.hash.slice(1));if(slug) openItem(slug,false)}
  filters.addEventListener('click',e=>{const b=e.target.closest('[data-cat]');if(!b)return;active=b.dataset.cat;filters.querySelectorAll('.bpl-filter').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));render()});
  search.addEventListener('input',render);
  grid.addEventListener('click',e=>{const b=e.target.closest('[data-open]');if(b)openItem(b.dataset.open)});
  dialog.addEventListener('click',e=>{if(e.target===dialog)closeDialog()});
  dialog.addEventListener('cancel',e=>{e.preventDefault();closeDialog()});
  window.addEventListener('hashchange',openFromHash);
  loadIndex().catch(()=>grid.innerHTML='<div class="bpl-empty">No se pudo cargar la biblioteca.</div>');
})();
